import { useState } from 'react';
import { LogOut } from 'lucide-react';
import {
  Popover,
  PopoverContent,
  PopoverTrigger
} from '@/components/ui/popover';
import { useAuth } from '@/hooks/use-auth';

export function SidebarUserMenu() {
  const [open, setOpen] = useState(false);
  const { currentUser, signOut } = useAuth();
  const name = currentUser?.name || currentUser?.email || '';
  const initial = (name[0] || '?').toUpperCase();

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        {/* One layout open or closed: the avatar stays put and the name clips and fades with the width. */}
        <button className='flex w-full items-center gap-2.5 overflow-hidden rounded-[10px] p-0.5 text-left transition-colors hover:bg-gray-300 group-data-[collapsible=icon]:hover:bg-transparent'>
          <span className='flex size-8 shrink-0 items-center justify-center rounded-full border border-border bg-white text-sm font-medium text-foreground'>{initial}</span>
          <span className='min-w-0 transition-opacity duration-200 group-data-[collapsible=icon]:opacity-0'>
            <span className='block truncate text-[13px] font-medium leading-4 text-ink'>{name}</span>
            <span className='block truncate text-xs leading-[14px] text-gray-800'>{currentUser?.email}</span>
          </span>
        </button>
      </PopoverTrigger>
      <PopoverContent
        side='right'
        align='end'
        sideOffset={12}
        className='w-56 rounded-xl border border-border bg-white p-2 shadow-sm'
      >
        <div className='flex items-center gap-2.5 px-2 py-2'>
          <div className='flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-muted text-sm font-medium text-foreground'>
            {initial}
          </div>
          <div className='min-w-0'>
            <p className='truncate text-sm font-semibold'>{name}</p>
            <p className='truncate text-xs text-muted-foreground'>
              {currentUser?.email}
            </p>
          </div>
        </div>
        <div className='mx-2 mb-1 border-t border-border' />
        <button
          onClick={signOut}
          className='flex w-full items-center justify-center gap-2 rounded-lg bg-red-50 px-3 py-2 text-xs font-medium text-red-500 transition-colors hover:bg-red-100'
        >
          <LogOut className='size-3' />
          Log out
        </button>
      </PopoverContent>
    </Popover>
  );
}
